import ReactMarkdown from "react-markdown";
// import html from "remark-html";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";

import { slugify } from "client-server-shared/utils/text-utils";
import React from "react";

const isExternalLink = (url: string) => {
  if (!url.startsWith("https") && !url.startsWith("http")) {
    return false;
  }
  if (url.includes("junia")) {
    return false;
  }
  return true;
};

const modifyLink = (rest: Record<string, any>) => {
  const url = rest.href;
  if (!isExternalLink(url)) {
    if (url.includes("?same-page")) {
      return {
        ...rest,
        href: url.replace("?same-page", ""),
      };
    }
    return {
      ...rest,
      target: "_blank",
    };
  }
  if (url.includes("?follow")) {
    return {
      ...rest,
      target: "_blank",
      href: url.replace("?follow", ""),
    };
  }
  return {
    ...rest,
    target: "_blank",
    href: url.replace("?nofollow", ""),
    rel: "nofollow noopener",
  };
};

const AnchorTag = React.memo(({ node, ...rest }) => {
  const valid = React.useMemo(() => modifyLink(rest), [rest.href]);
  return <a {...valid}>{rest.children}</a>;
});

const HeadingRenderer = React.memo(({ children, ...props }) => {
  let text = "";

  if (props.node.children.length > 0) {
    if (
      !props.node.children[0].value &&
      props.node.children[0].children.length > 0
    ) {
      text = slugify(props.node.children[0].children[0].value);
    } else {
      text = slugify(props.node.children[0].value);
    }
  }
  return React.createElement(
    props.node.tagName,
    {
      id: text,
      ...props,
    },
    children
  );
});
const Heading2Renderer = React.memo(({ children, ...props }) => {
  let text = "";

  if (props.node.children.length > 0) {
    if (
      !props.node.children[0].value &&
      props.node.children[0].children.length > 0
    ) {
      text = slugify(props.node.children[0].children[0].value);
    } else {
      text = slugify(props.node.children[0].value);
    }
  }

  return React.createElement(
    "h2",
    {
      id: text,
      ...props,
    },
    children
  );
});

const MarkdownRenderer = ({
  input,
  className = "markdown-content",
  components = {},
}) => {
  const basePathLink =
    process.env.NODE_ENV === "production"
      ? process.env.NEXT_PUBLIC_BASEPATH ?? ""
      : "";

  return (
    <ReactMarkdown
      components={{
        h1: Heading2Renderer,
        h2: HeadingRenderer,
        h3: HeadingRenderer,
        h4: HeadingRenderer,
        a: AnchorTag,
        ...components,
      }}
      rehypePlugins={[rehypeRaw, remarkGfm]}
      remarkPlugins={[]}
      className={className}
      children={input}
    />
  );
};

export default MarkdownRenderer;
